var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-2 pb-40 md:py-6 mx-auto px-4 sm:px-6 md:px-8"},[_c('suppliers-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }